"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInfo = void 0;
const getCharge_js_1 = require("../../util/getCharge.js");
const getMF_js_1 = require("../../util/getMF.js");
/**
 * @description Get the info of a molecule
 * @param {import('openchemlib').Molecule} molecule
 * @param {Map} moleculesInfo Map of molecules info
 * @returns {Object} object with molfile, idCode, mf, em, mz and charge
 */
function getInfo(molecule, moleculesInfo) {
    if (moleculesInfo.has(molecule)) {
        return moleculesInfo.get(molecule);
    }
    let em = molecule.getMolecularFormula().absoluteWeight;
    let charge = (0, getCharge_js_1.getCharge)(molecule);
    let mz = em / (charge === 0 ? 1 : Math.abs(charge));
    const reactantInfo = {
        molfile: molecule.toMolfile(),
        idCode: molecule.getIDCode(),
        mf: (0, getMF_js_1.getMF)(molecule).mf,
        em,
        mz,
        charge,
    };
    moleculesInfo.set(molecule, reactantInfo);
    return reactantInfo;
}
exports.getInfo = getInfo;
//# sourceMappingURL=getReactantInfo.js.map